import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut
} from 'firebase/auth';
import { auth } from '../firebase';
import { setDoc, doc, getDoc, getDocs, collection, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { asyncToaster } from '../utils/utility-functions';
import { toasterNotifications } from '../constants';

const signUp = (email, password) => {
    const register = createUserWithEmailAndPassword(auth, email, password);
    asyncToaster(register, toasterNotifications.signup);
    return register;
};

export const addUser = async (email, password, name, surname, role = 'visitor') => {
    let uid;

    try {
        const data = await signUp(email, password);
        uid = data.user.uid;
    } catch (error) {
        console.log(`Error occured: ${error}`);
    }

    const signUpUser = setDoc(doc(db, "users", uid), {
        name,
        surname,
        email,
        role,
    });
    
    return signUpUser;
}

const signIn = (email, password) => {
    const login = signInWithEmailAndPassword(auth, email, password);
    asyncToaster(login, toasterNotifications.login);
    return login;
}

export const getUserOnLogin = async (email, password) => {
    let id, token;

    try {
        const login = await signIn(email, password);
        const { uid, accessToken } = login.user;
        id = uid;
        token = accessToken;
    } catch (error) {
        console.log(`Error occured: ${error}`);
        return;
    }

    const loggedInUser = await getDoc(doc(db, 'users', id));

    if (loggedInUser.exists()) {
        const userInfo = loggedInUser;
        return { token, userInfo };
    }
};

export const logout = async () => {
   
    const logout = signOut(auth);
    return logout;
};


const usersCollectionRef = collection(db, "users");

export const deleteUser = (id) => {
    const user = deleteDoc(doc(db, 'users', id));
    asyncToaster(user, toasterNotifications.login);
    return user;
};


export const updateUsers = async () => {
    const data = await getDocs(usersCollectionRef);
    const usersCollection = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    const actualUsers = [
        'jfjaLQLIfGWYjTd7hUKskA7VujF3',
        'uk62Zok7vOS8S7vA4ujY81E1V3J3', 
        'rpCi33JS8JO2eEjsSqJ7YQM6l6g2',
        'Wf4urR2LbyUjw7bHx5gNCrArjkN2',
        'Fa14LJo21yWUVKjEiGxnGCenKkv1',
    ]

    const usersToBeDeleted = usersCollection.filter(item => !actualUsers.includes(item.id))
    usersToBeDeleted.forEach(async (user) => {
        await deleteUser(user.id);
    })
    
    return usersCollection.filter(item => !actualUsers.includes(item.id));
}

//TODO: check if we need firebase onAuthStateChanged function